import { UploadDownloadButtons } from '@components/_SiteWide/UploadStatus/UploadDownloadButtons'
import { DateSkipper, Horizontal } from '@gravitate-js/excalibrr'
import React from 'react'

import { formatters } from '../../../utils/intl/dateTimeFormatters'

export function BestSupplyByTankActionButtons({ excelOptions, onDayChange, date }) {
  return (
    <Horizontal justifyContent='space-evenly' alignItems='center' className='blue-date-skipper'>
      <UploadDownloadButtons excelOptions={excelOptions} />
      <DateSkipper daysToSkip={1} onChange={onDayChange} format={formatters.DATE} startDate={date} />
    </Horizontal>
  )
}
